import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import getRelativeDetails from "./RelativeDetails";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import getSilverRelativeDetails from "../Silver/SilverRelativeDetails";

class Relatives extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    let rows = [];
    let recCount = 0;
    const { isSilverReport } = props;
    if (isSilverReport) {
      const records = _.get(props.node, "relatives[0].relative");
      if (records !== undefined && records.length > 0) {
        let recs = [];
        _.forEach(records, (record, relIndex) => {
          recs = recs.concat(
            getSilverRelativeDetails(props, record, relIndex, -1)
          );
        });
        if (recs.length > 0)
          rows.push(
            <Table.Row key={"rel_rows"}>
              <Table.Cell>{recs}</Table.Cell>
            </Table.Row>
          );
        recCount = recs.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    } else {
      const records = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].relatives[0].relative"
      );
      if (records !== undefined && records.length > 0) {
        _.forEach(records, (record, relIndex) => {
          rows = rows.concat(getRelativeDetails(props, record, relIndex, -1));
        });
        recCount = rows.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Relatives"}
        rows={this.state.rows}
      />
    );
  }
}

export default Relatives;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/Relatives.js